import { notification } from 'antd';
import { PureComponent, ReactNode } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { getAccessControl } from '../store/AccessControl';

type Props = {
    isAccessControlSetup?: boolean;
};

class RescrictionWrapper extends PureComponent<RouteComponentProps & Props> {
    checkForAccess = (): void => {
        if (
            !getAccessControl().canAccessRoute(this.props.match.path) ||
            !getAccessControl().canAccessRoute(this.props.location.pathname)
        ) {
            notification.error({
                message: 'Access Denied',
                description: 'You do not have access to this page',
                duration: 5,
            });
            this.props.history.replace('/app');
            return;
        }
    };

    componentDidMount(): void {
        this.checkForAccess();
    }

    componentDidUpdate(prevProps: RouteComponentProps): void {
        if (prevProps.location.pathname !== this.props.location.pathname) {
            this.checkForAccess();
        }
    }

    render(): ReactNode {
        if (!getAccessControl().canAccessRoute(this.props.match.path)) {
            return null;
        }

        return this.props.children;
    }
}

export default RescrictionWrapper;
